import { useState, useCallback } from 'react';
import { message } from 'antd';
import { m309Api, QueryParams, ResultRow, UnitSummary } from '../../../services/m309Api';

export function useM309Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ResultRow[]>([]);
  const [summary, setSummary] = useState<UnitSummary[]>([]);
  const [total, setTotal] = useState(0);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await m309Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setSummary(resp.summary || []);
        setTotal(resp.total);
        setNoData(false);
      } else {
        setData([]);
        setSummary([]);
        setTotal(0);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setSummary([]);
    setTotal(0);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, summary, total, queried, noData, runQuery, reset };
}
